import { useEffect, useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const FALLBACK_ABOUT_IMAGE = "https://customer-assets-lqy194kg.emergentagent.net/job_barber-reserve-test/artifacts/tmwxrwxd_elite%20the%20barber%20voorbeeld.webp";

export const About = () => {
  const { t, lang } = useLanguage();
  const [aboutPhoto, setAboutPhoto] = useState(null);

  useEffect(() => {
    api.get("/photos", { params: { section: "about" } }).then(({ data }) => setAboutPhoto(data[0] || null)).catch(() => setAboutPhoto(null));
  }, []);

  const aboutImageUrl = aboutPhoto ? `${BACKEND_URL}${aboutPhoto.url}` : FALLBACK_ABOUT_IMAGE;
  const aboutImageAlt = aboutPhoto ? ((lang === "nl" ? aboutPhoto.alt_text_nl : aboutPhoto.alt_text_en) || "EliteTheBarber") : "Barbier aan het werk bij EliteTheBarber";

  return (
    <section data-testid="about-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="order-2 lg:order-1">
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-6 tracking-tight">{t("about.title")}</h2>
          <p className="text-white/70 text-base leading-relaxed">{t("about.text")}</p>
        </div>
        <div className="order-1 lg:order-2 aspect-[4/5] overflow-hidden rounded-xl border border-white/5">
          <img data-testid="about-image" src={aboutImageUrl} alt={aboutImageAlt} className="w-full h-full object-cover" />
        </div>
      </div>
    </section>
  );
};
